import { SessionService } from '../session-service/index';
import { getLang } from '../context-utils';

/** Get and clean Json **/
export function getJson(data) {
  if (typeof data == 'undefined' || data == null) {
    return null;
  }
  if (typeof data !== 'string') {
    return data;
  }
  let response = data.replace(/^\s*{\s*}\s*&&\s*/, '');
  try {
    response = JSON.parse(response);
  } catch (err) {
    console.warn('can not parse data as JSON', err);
  }
  return response;
}

/** Add Extra infos **/
export async function addExtraInfos(options) {
  let datas = options || {};
  let sessionId = '';
  if (datas.httpSessionId) {
    sessionId = datas.httpSessionId;
  } else {
    // traiter spécifiquement pour économiser un appel dans le cas ou le httpSessionId est fourni
    try {
      sessionId = await SessionService.getSession();
    } catch (error) {
      console.error(error);
    }
  }

  return {
    ...datas,
    httpSessionId: sessionId,
    t: datas.t || Date.now(),
    lang: datas.lang || getLang()
  };
}

/** Convert an object into a string as a url parameters */
export function convertToUrlParams(data) {
  return data
    ? Object.keys(data)
        .filter((key) => data[key] != null)
        .map(
          (key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
        )
        .join('&')
    : '';
}
